export const preloadImg = (...args: string[]): void => {
	for (let i = 0; i < args.length; i++) {
		const img = new Image();
		img.src = args[i];
	}
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const preloadVideos = (...src: any): void => {
	const preloadNode = document.querySelector('#preload');

	for (let i = 0; i < src.length; i++) {
		const video = new Image();
		video.src = src[i];

		const videoNode = document.createElement('video');
		const source = document.createElement('source');
		source.src = src;
		source.type = 'video/mp4';
		videoNode.appendChild(source);
		preloadNode?.appendChild(videoNode);
	}
};
